import { createAction, props } from '@ngrx/store';
import { TokenBalance } from 'src/app/services/licenses/licenses.model';

export const loadTokens = createAction('[Tokens] Load Tokens', props<{ tenantId?: string }>());
export const loadTokensSuccess = createAction('[Tokens] Load Tokens Success', props<{ tokenBalance: TokenBalance | null }>());
export const loadTokensFailed = createAction('[Tokens] Load Tokens Failed', props<{ error: any }>());

// Local update (e.g. notify from client after a mutation)
export const updateTokens = createAction('[Tokens] Update Tokens', props<{ tokenBalance: TokenBalance | null }>());
